import type LenisType from 'lenis';
import { createContext } from "react";
import { ToastType } from '@/components/ToastHandler';

export const LenisContext = createContext({
  lenisInstance: null as LenisType | null,
  requestToasts: [] as ToastType[],
  startLoader: () => { },
  initializeToasts: (toasts: ToastType[]) => { },
  addToast: (toast: ToastType) => { },
  removeToast: (id: string) => { },
  scrollToElement: (element: HTMLElement, offset?: number) => { }
});